import { CurrencyCode } from '../../common';
import { AdWordsAdEntityFields, AdWordsEntityIdentityFields } from './common';

export interface BrandAwarenessMetrics {
    currencyCode: CurrencyCode | null;
    cost: number;
    impressions: number;
    clicks: number;
}

export interface BrandAwarenessLocationStats extends BrandAwarenessMetrics {
    locationId: number;
    entityTotals: Array<BrandAwarenessAdEntityStats | BrandAwarenessEntityStats>;
}

export interface BrandAwarenessEntityStats extends BrandAwarenessMetrics, AdWordsEntityIdentityFields {}

export interface BrandAwarenessAdEntityStats extends BrandAwarenessEntityStats, AdWordsAdEntityFields {}

export type BrandAwarenessStats = BrandAwarenessAdEntityStats | BrandAwarenessEntityStats | BrandAwarenessLocationStats;

export function isBrandAwarenessLocationStats(stats: BrandAwarenessStats): stats is BrandAwarenessLocationStats {
    return !!(stats as Partial<BrandAwarenessLocationStats>).entityTotals;
}

export function isBrandAwarenessAdEntityStat(stats: BrandAwarenessStats): stats is BrandAwarenessAdEntityStats {
    const pref = (stats as Partial<BrandAwarenessAdEntityStats>).devicePreference;
    return !!pref || pref === '';
}
